import React, { useState } from "react";
import { Tabs, Tab, Box, Typography } from "@mui/material";
import { TabsStyled } from "./tabs.styles";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  className?: string;
}

const TabPanel: React.FC<TabPanelProps> = ({
  children,
  value,
  index,
  ...other
}) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box className="tabs-children" sx={{ py: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

const a11yProps = (index: number) => ({
  id: `tab-${index}`,
  "aria-controls": `tabpanel-${index}`,
});

interface ReusableTabsProps {
  tabs: { label: string; content: React.ReactNode }[];
  onTabChange?: (event: any) => void;
}

const ReusableTabs: React.FC<ReusableTabsProps> = ({ tabs, onTabChange }) => {
  const [value, setValue] = useState(0);

  const handleChange = (
    event: React.SyntheticEvent | any,
    newValue: number
  ) => {
    setValue(newValue);
    if (onTabChange) onTabChange(event?.target?.innerText);
  };

  return (
    <TabsStyled>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="reusable tabs"
        variant="scrollable"
        scrollButtons="auto"
      >
        {tabs.map((tab, index) => (
          <Tab key={index} label={tab.label} {...a11yProps(index)} />
        ))}
      </Tabs>
      {tabs.map((tab, index) => (
        <TabPanel
          className="pannel-wrapper"
          key={index}
          value={value}
          index={index}
        >
          {tab.content}
        </TabPanel>
      ))}
    </TabsStyled>
  );
};

export default ReusableTabs;
